var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { loading } from 'elements/Loading';
import { inject, observer } from 'mobx-react';
import { Container, Row } from 'reactstrap';
import { t, T } from 'helpers/i18n';
import CuadroCard from '../../../components/CuadroCard';
import Theme from '../../../Theme';
import { ButtonsBar, StyledButton } from '../../../Styles';
var UsedGaugesView = /** @class */ (function (_super) {
    __extends(UsedGaugesView, _super);
    function UsedGaugesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleUpdate = function () {
            _this.props.store.usedGaugeStore.read();
        };
        return _this;
    }
    UsedGaugesView.prototype.render = function () {
        var usedGauges = this.props.store.usedGaugeStore.datas;
        console.log('usedGauges: ', usedGauges);
        return (React.createElement("div", null,
            React.createElement(Container, { className: "mt-3" },
                React.createElement(Row, { className: "mt-3" }, usedGauges.map(function (usedGauge) { return (React.createElement(CuadroCard, { key: usedGauge.id, title: usedGauge.stretch.name, content: T('usedGauges'), value: usedGauge.inside ? usedGauge.inside.toString() : '0' })); }))),
            React.createElement("div", { style: {
                    height: 1,
                    position: 'absolute',
                    bottom: 0,
                    borderBottom: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
                } }),
            React.createElement(ButtonsBar, null,
                React.createElement(StyledButton, { onClick: this.handleUpdate }, t('update')))));
    };
    UsedGaugesView = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.usedGaugeStore.read()
        ]; }),
        observer
    ], UsedGaugesView);
    return UsedGaugesView;
}(Component));
export default UsedGaugesView;



//////////////////
// WEBPACK FOOTER
// ./src/modules/UsedGauges/containers/UsedGaugesView.tsx
// module id = 1601
// module chunks = 0